module.exports = __webpack_public_path__ + "static/media/CommentIcon.10ed8dff.svg";